<template>
  <div class="com">
    <FinalInfo></FinalInfo>
    <div class="desc">
      Your Report and Status Updates will be sent to the mobile number
      (SMS/text) and email address you provided.
    </div>
    <div class="checkbox-items-wrap">
      <div class="label-checkbox">
        <div class="checkbox-wrap">
          <input type="checkbox" class="checkbox" v-model="sampling_detail" />
          <span class="slider"></span>
        </div>
        <span class="checkbox-txt">
          I've reviewed and confirmed my sampling details.
        </span>
      </div>
      <div class="label-checkbox">
        <div class="checkbox-wrap">
          <input
            type="checkbox"
            class="checkbox"
            v-model="term_and_condition"
          />
          <span class="slider"></span>
        </div>
        <span class="checkbox-txt">
          I have read and agree to
          <span
            @click="showTerms"
            @click.stop="stopPropagation"
            class="terms-link"
          >
            Terms of Use.
          </span>
        </span>
      </div>
    </div>
    <button
      class="btn"
      @click="openReviewModal"
      @click.stop="stopPropagation"
      :disabled="!term_and_condition || !sampling_detail"
    >
      Submit
    </button>
    <button class="back-btn" @click="prev">Go back</button>
    <ReviewModal
      v-if="reviewModal"
      @closeModal="closeReviewModal"
      @submit="switchStep"
    ></ReviewModal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import FinalInfo from "../FinalInfo";
import ReviewModal from "../ReviewModal";

export default {
  name: "Step4",
  data() {
    return {
      term_and_condition: false,
      sampling_detail: false,
      reviewModal: false
    };
  },
  components: {
    FinalInfo,
    ReviewModal
  },
  computed: {
    ...mapGetters(["userInfo", "testKitDetails"])
  },
  methods: {
    ...mapActions(["confirmations", "simplingDetails"]),
    showTerms() {
      this.$emit("showTerms", true);
    },
    switchStep() {
      this.simplingDetails(this.testKitDetails).then(res => {
        this.confirmations({
        ...this._data,
        kit_id: this.userInfo.kit_id
      }).then(res => {
        this.$emit("nextStep", 1);
        });
      });
    },
    prev() {
      this.$emit("prevStep", 1);
    },
    showReviewModal(boolean) {
      this.reviewModal = boolean;
    },
    closeReviewModal(boolean) {
      this.reviewModal = boolean;
    },
    openReviewModal() {
      this.reviewModal = true;
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.checkbox-items-wrap {
  margin-top: 16px;
}
.label-checkbox {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 20px 0 0 0;
  position: relative;
}
.checkbox-txt {
  font-size: 16px;
  width: 70%;
  font-family: TTNormsRegular, sans-serif;
  color: $gray;
}
.checkbox {
  opacity: 0;
  width: 100%;
  margin: 0;
  height: 100%;
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
}
.checkbox-wrap {
  position: relative;
  width: 56px;
  height: 24px;
  margin-right: 20px;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 28px;
  width: 28px;
  left: 0;
  bottom: -2px;
  box-shadow: 0 0 2px 1px $boxShadow;
  background-color: $white;
  transition: 0.4s;
  border-radius: 100%;
}
.checkbox:checked + .slider {
  background-color: $green;
}

.checkbox:checked + .slider:before {
  transform: translateX(28px);
}
.btn {
  background-color: $green;
  width: 100%;
  max-width: 183px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  margin: 36px auto 0 auto;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  background-color: transparent;
  font-size: 16px;
  margin: 36px auto 0 auto;
  font-family: TTNormsMedium, sans-serif;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.desc {
  text-align: center;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  color: $green;
}
.terms-link {
  color: $green;
  cursor: pointer;
  font-size: 16px;
  font-family: TTNormsRegular, sans-serif;
}
@media screen and (max-width: 425px) {
  .checkbox-txt {
    width: 80%;
  }
}
</style>
